export enum GlobalGuardianPointOfContactRoles {
  AccountManager = 'AccountManager',
  BD_Representative = 'BD_Representative',
  SubjectMatterExpert = 'SubjectMatterExpert',
  TechnicalEngineer = 'TechnicalEngineer',
  LeadershipPOC = 'LeadershipPOC',
}
